import React, { FC, useEffect, useState, useMemo } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useSoReportModel } from "../soReportModel";
import { IVRMSoReportDetail } from "../soReportService";
import { useDictModel } from "@/views/base/dict/dictModel";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";
import YhTootip from "@/components/YhTootip";

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys,
        setHistoryVisible,
        setHistoryRow,
    } = useSoReportModel();
    const onHistoryModel = (record: IVRMSoReportDetail) => {
        setHistoryVisible(true)
        setHistoryRow(record)
    }
    const { getTreeNodeName } = useDictModel(() => []);
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();

    useEffect(() => {
        loadData();
    }, [])

    const defaultColumns: ColumnsType<IVRMSoReportDetail> = [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            align: "center",
            render: (t, r, i) => i + 1
        }, {
            title: '客户名称',
            width: 200,
            dataIndex: 'customerName',
            render: text => <Tooltip placement="topLeft" title={text} arrowPointAtCenter><p className="ellipsis">{text}</p></Tooltip>
        }, {
            title: '客户类型',
            width: 120,
            dataIndex: 'customerTypeName',
        }, {
            title: '单据编号',
            width: 180,
            dataIndex: 'code',

        }, {
            title: '单据类型',
            width: 100,
            dataIndex: 'tradeTypeName',
        }, {
            title: '单据状态',
            width: 100,
            dataIndex: 'status',
            render: (text) => getTreeNodeName(text)
        }, {
            title: '销售类型',
            width: 80,
            dataIndex: 'salesTypeName',
        }, {
            title: '结算类型',
            width: 80,
            dataIndex: 'payTypeName',
        }, {
            title: '商品名称',
            width: 160,
            dataIndex: 'materialName',
        }, {
            title: '商品编号',
            width: 200,
            dataIndex: 'materialCode',
            render: (text: any, record: any, index: number) => <Tooltip placement="topLeft" title={text}><p className="ellipsis click-span" onClick={(e) => { e.stopPropagation(); onHistoryModel(record) }}>{text}</p></Tooltip>,
        }, {
            title: '商品类型',
            width: 160,
            dataIndex: 'typeName',


        }, {
            title: '销售数量',
            width: 100,
            dataIndex: 'num',
        }, {
            title: '销售价格',
            width: 100,
            dataIndex: 'price',
            render: (text) => `￥${text ?? 0}`
        }, {
            title: '销售金额',
            width: 110,
            dataIndex: 'amount',
            render: (text) => `￥${text ?? 0}`
        }, {
            title: '销售成本',
            width: 110,
            dataIndex: 'costAmount',
            render: (text) => `￥${text ?? 0}`
        }, {
            title: '销售毛利',
            width: 110,
            dataIndex: 'profit',
            render: (text) => `￥${text ?? 0}`

        }, {
            title: '制单人',
            width: 120,
            dataIndex: 'createUser',
        }, {
            title: '制单日期',
            width: 160,
            dataIndex: 'createTime',
        }, {
            title: '结算日期',
            width: 160,
            dataIndex: 'settleTime',
        }, {
            title: '物料编号',
            width: 100,
            dataIndex: 'insideCode',
        }, {
            title: '物料名称',
            width: 100,
            dataIndex: 'insideName',
        }, {
            title: '替换编号',
            width: 200,
            dataIndex: 'replaceCode',
        }, {
            title: '销售订单号',
            width: 180,
            dataIndex: 'transferCode',
        }, {
            title: '积压标记',
            width: 120,
            dataIndex: 'overstock',

        }, {
            title: '备注',
            width: 200,
            dataIndex: 'note',
        }, {
            title: '配件销售频次',
            width: 100,
            dataIndex: 'saleCount',
        }, {
            title: '配件销退频次',
            width: 100,
            dataIndex: 'sreturnCount',
        },
        {
            title: '所属站点',
            width: 250,
            fixed: "right",
            dataIndex: 'shopName',
            render: (text: any) => <YhTootip text={text} style={{ width: 250 }} />,
        }
    ];

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "saleDetailStatic", "roleCodes": roles };
        return getRoleColumns("saleDetailStatic", "主单", defaultColumns, params);
    }, [roles, dataSource]);
    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            bordered
            rowKey={record => record.id}
            // rowSelection={{
            //     selectedRowKeys: selectedRowKeys, //记录选中
            //     //全部选中时  (存string[])
            //     onSelectAll: (selected, selectedRows, changeRows) => {
            //         let changeRowId = changeRows.map(item => item.id);
            //         selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
            //             : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
            //     },
            //     onSelect: (record) => onRow(record.id),
            // }}
            columns={roleColumns}
            dataSource={dataSource}
            pagination={{
                showSizeChanger: true,
                ...pgCfg,
                defaultPageSize: 25,
                pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                position: ["bottomRight"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            // onRow={record => ({
            //     onClick: () => onRow(record.id)
            // })}
            scroll={{ x: 'max-content', y: "calc(100vh - 340px)" }}
        />
    )
}